import React from 'react';
import s from './centered-loader.scss';
import { Loader } from 'wix-style-react';
export var isBrowser = function () { return typeof window !== 'undefined'; };
export var CenteredLoader = function () {
    isBrowser() && window.scrollTo(0, 0);
    return (React.createElement("div", { className: s.loaderPosition },
        React.createElement(Loader, { status: "loading" })));
};
//# sourceMappingURL=centered-loader.js.map